// Based on: https://medium.com/@felquis/manipula%C3%A7%C3%A3o-de-pseudo-elements-com-javascript-7c8e2334885e

import Vue from 'vue'
import './styles.scss'

Vue.directive('pill-count', {
    bind: handler,
    componentUpdated: handler,
})

function handler(el, binding) {
    const value = binding.value

    if (!isValid(value)) {
        return removePillCountClassFromElement(el)
    }

    const count = parseValueToCount(value)
    addPillCountClassToElement(el)
    setElementDataContent(el, count)
}

const isValid = (value) => value > 0

const parseValueToCount = (count) => (count > 99 ? '99+' : count)

const setElementDataContent = (el, data) => el.setAttribute('data-content', data)

const addPillCountClassToElement = (el) => el.classList.add('pill-count-directive')

const removePillCountClassFromElement = (el) => el.classList.remove('pill-count-directive')
